import { faGraduationCap, faNotdef } from "@fortawesome/pro-regular-svg-icons";
import { faBullseyeArrow } from "@fortawesome/pro-duotone-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import TaskTypeIcon from "../types/dtos/tasks/advanced-tasks/ClientTaskTypeIcon";

export const taskTypeIconHelper = {
  getTaskTypeIcon(taskTypeIcon: TaskTypeIcon): IconDefinition {
    switch (taskTypeIcon) {
      case "GOALS":
        return faBullseyeArrow;
      case "DEVELOPMENT":
        return faGraduationCap;
      default:
        return faNotdef;
    }
  },
};

export default taskTypeIconHelper;
